/**
 * App root. Wires the router into the React tree; intentionally kept
 * thin so global providers (React Query, etc.) added in later
 * milestones have one obvious place to land.
 *
 * v1.1 A4: audio-unlock tracking is started here at App-mount, not
 * inside SoundUnlockBanner. The banner only mounts on the dashboard
 * AFTER its first successful poll, which means the capture-phase
 * listeners would otherwise miss every gesture made on the login page
 * (and the very click that brought the user to the dashboard). With
 * tracking installed at the root, the login submit click itself is the
 * unlock gesture, so the first keyword chime after a fresh load can
 * actually play.
 */

import { useEffect } from "react";
import { RouterProvider } from "react-router-dom";
import { QueryClientProvider } from "@tanstack/react-query";
import { router } from "./router";
import { queryClient } from "./lib/queryClient";
import { startInteractionTracking } from "@/lib/sounds";

export function App() {
  useEffect(() => {
    // Idempotent — safe to call again from SoundUnlockBanner.
    startInteractionTracking();
  }, []);
  return (
    <QueryClientProvider client={queryClient}>
      <RouterProvider router={router} />
    </QueryClientProvider>
  );
}
